<div class="element">
  <div class="header">
    <h3>
      <a [routerLink]="['/details', element.therapeuticArea.id]">
        {{ element.therapeuticArea.name }}</a
      >
      <button
        class="secondary download"
        aria-label="download report"
        *ngIf="false"
      >
        <mat-icon>file_download</mat-icon>
      </button>
    </h3>
    <a class="secondary" [routerLink]="['/details', element.therapeuticArea.id]"
      >More details</a
    >
  </div>
  <div class="body">
    <div class="risk-scoring">
      <p class="subtitle">Risk Activities count</p>
      <div class="score-indicator">
        {{ getScore(element.elements) | numberAbbreviate }}
      </div>
    </div>

    <div class="flag-count">
      <p class="subtitle">Risk %</p>
      <div class="flag-container">
        <div
          *ngFor="let flag of getFlagCount(element.elements)"
          class="flag-item"
        >
          <span class="flag {{ flag.key }}"></span>
          <p>{{ flag.count }}%</p>
        </div>
      </div>
    </div>

    <div class="filler"></div>

    <div class="summary-container">
      <p class="subtitle exec">Excecutive summary</p>
      <p class="summary">
        {{ element.therapeuticArea.description }}
      </p>
    </div>
  </div>
</div>
